import Vue from 'vue';

export const GlobalLoader = new Vue({
    data() {
        return {
            count: 0,
            isSilent: false
        };
    },
    computed: {
        isActive() {
            return this.count > 0 && !this.isSilent;
        }
    },
    methods: {
        start() {
            this.count++;
        },
        stop() {
            this.count = Math.max(0, this.count - 1);
        },
        reset() {
            this.count = 0;
        },
        setSilent(val = true) {
            this.isSilent = val;
        },
        async wrap(promise) {
            this.start();
            try {
                return await promise;
            } finally {
                this.stop();
            }
        }
    }
});
